import lineWobble from '../elements/lineWobble.js';
lineWobble.register();
